import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UpdateQuoteClientData } from "../types";

export const updateQuoteClient = (payload: UpdateQuoteClientData) => {
   return apiClient<ApiResponse>("/v1/quote/client", {
      method: "PUT",
      body: payload
   })
}
